var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font_bold text_center"},[_vm._v(_vm._s(_vm.realData.title))]),_c('div',{ref:_vm.realRef,staticClass:"chart",staticStyle:{"height":"400px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }